<template>
  <div v-if="Array.isArray(selectedUsers)" class="flex flex-row items-center">
    <div
      class="flex flex-1 items-center gap-2 rounded-full border p-1"
      :class="{
        'pr-4': selectedUsers.length > 0
      }"
    >
      <AssignedAssetsModal
        :selected-users="selectedUsers"
        :selected-material-resources="selectedMaterialResources"
        :filter="filter"
        :edition-mode="editionMode"
        :avatar-size="avatarSize"
        :event="event"
        :all-users-availability-items="allUsersAvailabilityItems"
        :all-material-resources-availability-items="
          allMaterialResourcesAvailabilityItems
        "
        @modal-open="$emit('modal-open')"
        @modal-close="$emit('modal-close')"
        @add-user="(user_id) => $emit('add-user', user_id)"
        @add-material-resource="
          (material_resource_id) =>
            $emit('add-material-resource', material_resource_id)
        "
        @remove-material-resource="
          (material_resource_id) =>
            $emit('remove-material-resource', material_resource_id)
        "
      >
        <template #selected-user-panel="{ user }">
          <slot name="selected-user-panel" :user="user" />
        </template>
        <template #selectable-user-panel="{ user }">
          <slot name="selectable-user-panel" :user="user" />
        </template>
        <template #top-left-cta>
          <slot name="top-left-cta" :user="user" />
        </template>
      </AssignedAssetsModal>
      <slot name="user-list" :selected-users="selectedUsers">
        <template v-for="user in selectedUsers" :key="user.id">
          <UserAvatarPopover
            :user-id="user.id"
            :size="avatarSize"
            :disponibility="user.disponibility"
            message-text-group="PLA"
            related-model-type="App\Models\Event"
            :related-model-id="event.id"
            class="-mr-3"
          />
        </template>
      </slot>
      <template v-if="selectedMaterialResources?.length">
        <MaterialResourceAvatarPopover
          v-for="resource in selectedMaterialResources"
          :key="resource.id"
          :material-resource-id="resource.id"
          :size="avatarSize"
          :disponibility="resource.disponibility?.assignement_status ?? null"
          class="-mr-3"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import UserAvatarPopover from '@c/Avatar/Popover/UserAvatarPopover.vue'
import UserSelectorModal from '@c/BaseSelectorComponent/UserSelectorModal/UserSelectorModal.vue'
import MaterialResourceAvatarPopover from '@c/Avatar/Popover/MaterialResourceAvatarPopover.vue'

export default defineComponent({
  name: 'UserSelectorWrapper',
  components: {
    AssignedAssetsModal: UserSelectorModal,
    UserAvatarPopover,
    MaterialResourceAvatarPopover
  },
  props: {
    event: {
      type: Object,
      required: false,
      default: () => ({})
    },
    selectedUsers: {
      type: Array,
      required: true
    },
    selectedMaterialResources: {
      type: Array,
      required: false,
      default: null
    },
    filter: {
      type: Function,
      required: false,
      default: undefined
    },
    editionMode: {
      type: Boolean,
      required: false,
      default: false
    },
    avatarSize: {
      type: String,
      required: false,
      default: 'small'
    },
    allUsersAvailabilityItems: {
      type: Array,
      required: false,
      default: () => []
    },
    allMaterialResourcesAvailabilityItems: {
      type: Array,
      required: false,
      default: () => []
    },
    messageTextGroup: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: [
    'modal-open',
    'modal-close',
    'add-user',
    'add-material-resource',
    'remove-material-resource'
  ]
})
</script>

<style scoped></style>
